import React, { useState, useEffect } from "react";
import Marquee from "react-fast-marquee";
import axios from "axios";
import { API } from "@/config";

const SportsTicker = () => {
  const [games, setGames] = useState([]);

  useEffect(() => {
    fetchScores();
    const interval = setInterval(fetchScores, 60000);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- mount-only

  const fetchScores = async () => {
    try {
      const res = await axios.get(`${API}/sports-ticker`);
      setGames(res.data.games || []);
    } catch (err) {
      console.error("Error fetching scores:", err);
    }
  };

  if (games.length === 0) return null;

  return (
    <div className="sports-ticker" data-testid="sports-ticker">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {games.map((game, i) => (
          <div key={`ticker-${i}`} className="ticker-item">
            <span className={`ticker-league ${game.league.toLowerCase()}`}>
              {game.league}
            </span>
            <span className="ticker-team">{game.away_team}</span>
            <span className="ticker-score">{game.away_score}</span>
            <span className="ticker-at">@</span>
            <span className="ticker-team">{game.home_team}</span>
            <span className="ticker-score">{game.home_score}</span>
            <span className={`ticker-status ${game.state === 'in' ? 'live' : game.state === 'post' ? 'final' : ''}`}>
              {game.status}
            </span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default SportsTicker;
